import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [authState, setAuthState] = useState({
        isLoggedIn: false,
        isAdmin: false,
        token: null,
        custId: null,
        accountType: null,        // 'customer' | 'business'
        mustChangePassword: false,
    });

    // Restore login state on initial load
    useEffect(() => {
        const token = localStorage.getItem('token');
        const isAdmin = localStorage.getItem('isAdmin') === 'true';
        const custId = localStorage.getItem('Cust_id');
        const accountType = localStorage.getItem('accountType') || 'customer';
        const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';

        if (token) {
            setAuthState({
                isLoggedIn: true,
                isAdmin,
                token,
                custId,
                accountType,
                mustChangePassword,
            });
        }
    }, []);

    // Regular / business user login
    const login = (token, custId, accountType = 'customer', mustChangePassword = false) => {
        localStorage.setItem('token', token);
        localStorage.setItem('Cust_id', custId);
        localStorage.setItem('isAdmin', 'false');
        localStorage.setItem('accountType', accountType);
        localStorage.setItem('mustChangePassword', mustChangePassword ? 'true' : 'false');

        setAuthState({
            isLoggedIn: true,
            isAdmin: false,
            token,
            custId,
            accountType,
            mustChangePassword,
        });
    };

    // Called after a business account successfully changes their initial password
    const clearMustChangePassword = (newToken) => {
        localStorage.setItem('token', newToken);
        localStorage.setItem('mustChangePassword', 'false');
        setAuthState((prev) => ({
            ...prev,
            token: newToken,
            mustChangePassword: false,
        }));
    };

    // Admin login
    const loginAdmin = (token, custId) => {
        localStorage.setItem('token', token);
        localStorage.setItem('Cust_id', custId);
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('accountType', 'admin');
        localStorage.setItem('mustChangePassword', 'false');

        setAuthState({
            isLoggedIn: true,
            isAdmin: true,
            token,
            custId,
            accountType: 'admin',
            mustChangePassword: false,
        });
    };

    // Logout
    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('Cust_id');
        localStorage.removeItem('isAdmin');
        localStorage.removeItem('accountType');
        localStorage.removeItem('mustChangePassword');

        setAuthState({
            isLoggedIn: false,
            isAdmin: false,
            token: null,
            custId: null,
            accountType: null,
            mustChangePassword: false,
        });
    };

    return (
        <AuthContext.Provider value={{
            ...authState,
            login,
            loginAdmin,
            logout,
            clearMustChangePassword,
        }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === null) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
